function t(t, n) {
  return function () {
    if (--t < 1) return n.apply(this, arguments);
  };
}
export { t as default };